module.exports = __webpack_public_path__ + "static/media/anos_60.3c699c19.md";